export default "__VITE_ASSET__B56bLxmB__"